// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"bc93ece1","403":"f20046fe","455":"697bdb89","800":"4ef0aa4a","977":"96014919"}[chunkId] + ".chunk.js";
};